import { useEffect, useState } from "react"
import { formatInTimeZone } from "date-fns-tz"
import { useAccount } from "@apis/accounts/useAccounts"
import { useGetAddressQuery } from "@apis/address/useAddress"
import { useGetLocalWeatherQuery } from "@apis/weather/useWeather"

export const useLocalWeather = (account_id: string) => {
  const [now, setNow] = useState(() => new Date())

  const getAccountQuery = useAccount(account_id)
  const getAddressQuery = useGetAddressQuery(
    getAccountQuery.data?.service_address_guid,
  )
  const getLocalWeatherQuery = useGetLocalWeatherQuery(
    getAddressQuery.data?.zip,
  )

  useEffect(() => {
    const intervalId = setInterval(() => {
      setNow(new Date())
    }, 60_000)

    return () => clearInterval(intervalId)
  }, [])

  const timezone =
    getLocalWeatherQuery.data?.location?.tz_id ?? "America/New_York"
  const time = formatInTimeZone(now, timezone, "hh:mm a")

  const temperatureValue = getLocalWeatherQuery.data?.current?.temp_f
  const temperatureString = temperatureValue && `${temperatureValue} °F`

  return {
    temperature: temperatureString,
    time,
    weatherText: getLocalWeatherQuery.data?.current?.condition?.text,
    weatherIcon: `https:${getLocalWeatherQuery.data?.current?.condition?.icon}`,
    location:
      getAddressQuery.data &&
      `${getAddressQuery.data.city}, ${getAddressQuery.data.state_code}`,
    isSuccess: getLocalWeatherQuery.isSuccess,
  }
}
